import React from 'react'

import Select from '../Select'
import { TSelect } from '../Select/types'

// TODO: merge CurrencySelect and CurrencyPicker

const CurrencySelect = (props: TSelect): React.ReactElement => {
  return (
    <Select
      {...props}
      direct
      options={[
        { label: 'EUR', value: 'EUR' },
        { label: 'CHF', value: 'CHF' },
        { label: 'USD', value: 'USD' },
      ]}
      isSearchable={false}
      isFilterable={false}
      clearable={false}
    />
  )
}

export default CurrencySelect
